export const modeErrorMessages = {
  kiList:
    '以下いずれかの理由により、データを表示することができません\n\n・指定されている店舗のモードデータを参照する権限が設定されていない\n・設定した検索条件に当てはまる機種が存在しない\n・指定されているエリアが存在しない',
  replaceKi:
    'お気に入りで選択されていた機種が存在しませんでした\nそのため自動で別機種が選択されています。',
} as const;
